import { ReportHeader } from '../../header/report-header';
import { AssignmentsSideBarFilter } from './side-bar-filter/assignments-side-bar-filter';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import React, { useState } from 'react';
import { getAssignmentReportOperation } from './operations/get-assignment-report-operation';
import { AssignmentFilters } from './side-bar-filter/assignments-side-bar-filter.type';

export const ReportAssignments = () => {
  const [assignmentsData, setAssignmentsData] = useState([
    // ... your initial mock data ...
  ]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (filters: AssignmentFilters) => {
    try {
      setLoading(true);
      const data = await getAssignmentReportOperation(filters);
      setAssignmentsData(data);
    } catch (error) {
      console.error('Error fetching assignments:', error);
      // TODO: Add proper error handling/notification
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date: string | null) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('he-IL');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <ReportHeader
        title="דו״ח מטלות"
        description="דו״ח זה מציג מידע על מטלות בקורסים השונים, כולל מועדי הגשה ומצב הגשת ציונים. הדו״ח מאפשר מעקב אחר מטלות פתוחות ומטלות שהסתיימו בכל התכניות."
        metadata={[
          { label: 'מטרת הדו״ח', value: 'מעקב אחר מטלות והגשת ציונים' },
          { label: 'תדירות עדכון', value: 'יומי' },
        ]}
        category="education"
      />

      <div style={{ display: 'flex', gap: '20px' }}>
        <div
          style={{
            height: 'calc(100vh - 230px)',
            minHeight: '100%',
            width: '300px',
            minWidth: '250px',
          }}
        >
          <AssignmentsSideBarFilter onSearch={handleSearch} />
        </div>

        {/* Table Section */}
        <div style={{ flex: 1 }}>
          <DataTable
            value={assignmentsData}
            rows={10}
            rowHover
            loading={loading}
            rowClassName={() => 'cursor-pointer'}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyMessage={
              <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
            }
            dataKey="id"
            scrollable
            scrollHeight="calc(100vh - 300px)"
            tableStyle={{
              direction: 'rtl',
            }}
            className="assignments-table"
          >
            <Column
              field="branchName"
              header="שלוחה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="abstractProgramName"
              header="תוכנית לימודים"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="programStartYear"
              header="שנת התחלה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="programId"
              header="מזהה תוכנית"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="courseName"
              header="שם קורס"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="assignmentName"
              header="שם מטלה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="dueDate"
              header="תאריך אחרון להגשה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              body={(rowData) => formatDate(rowData.dueDate)}
            />
            <Column
              field="gradesPublishedUpdatedAt"
              header="תאריך פרסום ציונים"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
              body={(rowData) =>
                rowData.gradesPublishedUpdatedAt
                  ? formatDate(rowData.gradesPublishedUpdatedAt)
                  : 'טרם פורסם'
              }
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};
